import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Button } from 'components/ui/Button/Button'
import { Flex, PageWrapper } from 'styling/GlobalStyles'
import { OtherText } from 'styling/Typography'
import { useOpsBootstrap } from 'hooks/useOpsBootstrap'
import { deptByKey } from '../Shared/opsDepartments'
import { EnvironStrip } from './EnvironStrip'
import { TodaySwitcher } from './TodaySwitcher'
import { RaiseRequestModal } from './RaiseRequestModal'
import { RequestsSentByDept, RequestsToDept } from './TodayRequests'
import { TodayTitle } from './OpsToday.styled'

export const DeptToday = () => {
  const { deptKey } = useParams()
  const profiles = useSelector((s: RootState) => s.deptOpsProfiles.profiles)
  const isLoadingProfiles = useSelector((s: RootState) => s.deptOpsProfiles.isLoading)
  const dept = deptByKey(deptKey || '', profiles)
  const [raiseOpen, setRaiseOpen] = useState(false)
  useOpsBootstrap()

  if (isLoadingProfiles && !profiles.length) {
    return (
      <>
        <NavBar />
        <PageWrapper>
          <TodayTitle>Today</TodayTitle>
          <NoData text='Loading department profiles…' />
        </PageWrapper>
      </>
    )
  }

  if (!dept) {
    return (
      <>
        <NavBar />
        <PageWrapper>
          <TodayTitle>Today</TodayTitle>
          <TodaySwitcher activeKey={deptKey || ''} />
          <NoData text='This department is not set up yet.' />
        </PageWrapper>
      </>
    )
  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between center width='100%'>
          <TodayTitle>{dept.name}</TodayTitle>
          <Button variant='primary' onClick={() => setRaiseOpen(true)}>
            Raise request
          </Button>
        </Flex>
        <OtherText grey>Day Shift · 06:00–18:00</OtherText>
        <TodaySwitcher activeKey={dept.key} />
        <EnvironStrip />
        <RequestsToDept dept={dept} />
        <RequestsSentByDept dept={dept} />
        {raiseOpen && <RaiseRequestModal dept={dept} closeModal={() => setRaiseOpen(false)} />}
      </PageWrapper>
    </>
  )
}
